import { render, staticRenderFns } from "./DatesTabs.vue?vue&type=template&id=366cdf76&scoped=true"
import script from "./DatesTabs.vue?vue&type=script&lang=ts"
export * from "./DatesTabs.vue?vue&type=script&lang=ts"
import style0 from "./DatesTabs.vue?vue&type=style&index=0&id=366cdf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366cdf76",
  null
  
)

export default component.exports